module.exports = __webpack_public_path__ + "img/assistenza-strutture-fav.c1b9e4fc.png";